import type { ReactNode } from 'react';

export const symbol_sync_lock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-477q0 64 27.5 117.5T337-266v-94q0-13 8.5-21.5T367-390q13 0 21.5 8.5T397-360v170q0 13-8.5 21.5T367-160H197q-13 0-21.5-8.5T167-190q0-13 8.5-21.5T197-220h100q-64-48-100.5-108.5T160-477q0-89 46.5-167.5T340-765q11-5 21.5-.5T377-750q4 11 0 22.5T362-711q-62 32-102 94.5T220-477Zm549 18q-12 0-20.5-8.5T739-489q-2-49-27.5-102T626-694v94q0 13-8.5 21.5T596-570q-13 0-21.5-8.5T566-600v-170q0-13 8.5-21.5T596-800h170q13 0 21.5 8.5T796-770q0 13-8.5 21.5T766-740H665q73 66 103 129.5T800-490q0 13-9 22t-22 9ZM634-80q-17 0-28.5-11.5T594-120v-118q0-17 11.5-28.5T634-278h1v-39q0-35 23.5-58.5T717-399q35 0 58.5 23.5T799-317v39h1q17 0 28.5 11.5T840-238v118q0 17-11.5 28.5T800-80H634Zm41-198h84v-39q0-19-11.5-30.5T717-359q-19 0-30.5 11.5T675-317v39Z"
		/>
	</svg>
);
